import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';


class Sidebar extends Component {

    activeClass = pathName => this.props.location.pathname.indexOf(pathName) !== -1 ? 'active': null;

    render () {
        return (
            <aside className="sidebar">
                <ul className="menu">
                    <li className={ this.activeClass('/dashboard') }>
                        <Link to="/dashboard">Dashboard</Link>
                    </li>
                    <li className={ this.activeClass('/customer-orders') }>
                        <Link to="/customer-orders">Customer Orders</Link>
                    </li>
                    <li className={ this.activeClass('/menu') }>
                        <Link to="/menu">Menu Settings</Link>
                    </li>
                    <li className={ this.activeClass('/general-settings') }>
                        <Link to="/general-settings">General Settings</Link>
                    </li>
                </ul>
            </aside>
        )
    }
}

export default withRouter(Sidebar);


// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js